import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { inject, Injectable } from '@angular/core';
import { RsUtils } from '../utils/utils';

@Injectable({ providedIn: 'root' })
export abstract class RsTitleStrategy extends TitleStrategy {
  protected abstract appName: string;
  protected separator: string = '|';

  protected readonly title = inject(Title);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(this.buildTitle(snapshot));
  }

  public override buildTitle(snapshot: RouterStateSnapshot): string {
    const path = snapshot.url.split('/').splice(1)
      .map((pathname) => {
        if (RsUtils.isUUID(pathname)) {
          return pathname;
        }
        return RsUtils.upperFirst(pathname.replace(/-/g, ' '));
      })
      .join(` ${this.separator} `);

    if (!path) {
      return this.appName;
    }

    return `${this.appName} ${this.separator} ${this.trimAnchors(path)}`;
  }

  private trimAnchors(str: string): string {
    const anchorIndex = str.indexOf('#');
    return anchorIndex > 0 ? str.slice(0, anchorIndex) : str;
  }
}

export const provideTitleStrategy = <T extends new () => TitleStrategy>(titleStrategy: T) => {
  return {
    provide: TitleStrategy,
    useClass: titleStrategy
  };
};
